import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Hyperlink } from '../../../../../../components/Hyperlink';
import { MaterialIcon } from '../../../../../../components/material-icon/MaterialIcon';

import { doctrineAnalytics } from '../../../../../../utils/analyticsUtils';

import styles from './external_link.module.scss';

type Props = {
  url: string;
  articleId: string;
};

export const ExternalLink: FC<Props> = ({ url, articleId }) => {
  return (
    <div className={styles.container}>
      <MaterialIcon name="launch" className={styles.icon} />
      <Hyperlink
        className={styles.link}
        href={url}
        onClick={() =>
          doctrineAnalytics('Law SeeLegifrance', {
            articleId,
            reportOriginalQueryKey: true,
          })
        }
      >
        <FormattedMessage id="page/components/ExternalLink.tsx/1" />
      </Hyperlink>
    </div>
  );
};
